import { CompanyStatusInquiryReport } from "@herbjoy/apex-api-models";
import { IHttpService } from "angular";

export class IcdCorporationReportService {
    constructor(private $http: IHttpService, private apexApiUrl: string) {
        'ngInject';
    }

    retrieveCompanyStatusInquiryReports() {
        return this.$http<CompanyStatusInquiryReport[]>({
            method: "GET",
            url: `${this.apexApiUrl}/corporations/inquiry`,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }
}

